import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';

import { StateService } from '../../services/state.service';
import { AuthService, ApiService } from '../../services';
import { LoginModel, Role, User } from 'src/app/services/interfaces';
import { switchMap } from 'rxjs';
import { ItemService } from 'src/app/services';

@Component({
    selector: 'app-login',
    templateUrl: './silent-login.component.html',
    styleUrls: ['./silent-login.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SilentLoginComponent implements OnInit {

    public users: User[] = null;
    private user: User;
    private quotationId;
    private urlRole: string = "user";
    private readonly credentials: LoginModel = { username: 'demo@zilex.de', password: 'ge4gR&!his7QBs' } as const;

    constructor(private router: Router, private itemService: ItemService, private authService: AuthService, private stateService: StateService, private apiService: ApiService) { }

    public ngOnInit(): void {
        this.login();
    }
    private login() {

        this.credentials.password = this.credentials.password.trim()
        this.authService.singin(this.credentials)
            .subscribe({
                next: (response: User[]) => {
                    this.users = response;
                    this.selectUser(response[0]);

                },
                error: (err: any) => {

                }
            })

    }

    public selectUser(user: User) {

        this.stateService.store("jwt", user.token, true);

        this.apiService.getUserProps().subscribe({
            next: (resp: { propertyKey: string; propertyValue: string; }[]) => {

                resp.forEach((_prop) => {
                    user[_prop.propertyKey] = _prop.propertyValue;
                });

                // Save selected user
                this.stateService.store('user', user, true);
                this.user = user;
                this.createExtraProject();

            },
            error: (error) => {
               
            }
        })

    }
    private createExtraProject(): void {

        let title = new Date().toLocaleString();
        const observable = this.apiService.createQuotation({ idLang: this.user.idLang, idCurrency: this.user.idCurrency, quotationTitle: title })
            .pipe(switchMap((resp: any) => {
                  this.quotationId = resp.quotationId;

                return this.apiService.createItem({ itemNumber: '1', itemStatus: 'blank', itemType: 'ST', quotationId: resp.quotationId, itemTitle: 'demo', itemDescription: 'demo' })
            })).subscribe({
                next: (_newItemResp: any) => {
                    // Save ID of created item.
                    //this.itemId = _newItemResp.itemId;

                    this.cancelGuide(_newItemResp.itemId);
                    observable.unsubscribe();
                },
                error: (error) => {

                    observable.unsubscribe();
                }
            });
    };
    public cancelGuide(id): void {

        const observable = this.apiService.skipGuide(id).subscribe({
            next: (itemId: number) => {
                observable.unsubscribe();
                this.router.navigate([`${this.urlRole}/configurator`, this.quotationId, id, 'duty']);
            },
            error: (error) => {

            }
        })


    }

}